import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-upload-req-step-results',
  templateUrl: './upload-req-step-results.component.html'
})
export class UploadReqStepResultsComponent {

  @Input() step5Error: any = null;
  @Input() intelligencePreferences: any = {};
  @Input() currentScoreCandidateCounts: any = {};
  @Input() adjustedScoreCandidateCounts: any = {};
  @Input() loadingAdjustedCandidatesCountFlag: boolean;
  @Input() isOutreachEnabled: boolean;
  @Input() sendOutreachEmail;

  @Output() sendOutreachEmailChange = new EventEmitter<any>();

  onSendOutreachEmailUpdated(value) {
    this.sendOutreachEmail = value;
    this.sendOutreachEmailChange.emit(value);
  }
}
